import Button from "../../components/common/button/Button";
import SubHeader from "../../components/header/SubHeader";
import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getValidatedLimit} from "../../components/Utility";
import {fetchInternalBranchList, fetchInternalEmployeeList, fetchProductList} from "../../store/list-slice";
import {getDetailData, getOrderItemTableColumns, getOrderItemTableData} from "../../models/internalOrderModel";
import Detail from "../../components/common/detail/Detail";
import Table from "../../components/common/table/Table";
import {fetchInternalOrderById} from "../../store/order-internal-slice";
import {useLocation} from 'react-router-dom';
import {RoleSign} from "../../enums/enums";
import OrderInternalLog from "../../components/order/OrderInternalLog";

const DetailInternalOrder = () => {

    const params = useParams();
    const dispatch = useDispatch();
    const location = useLocation();

    const list = useSelector(state => state.list);
    const {items: productList} = list.product;
    const {pagination} = useSelector(state => state.purchase);
    const {limit, currentPage} = getValidatedLimit(pagination);
    const {items: internalBranch = []} = list.internalBranch || {};
    const {items: employee = []} = list.internalEmployee || {};

    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        if (params.interOrderId) {
            dispatch(fetchInternalOrderById({...userRole, id: params.interOrderId}));
            dispatch(fetchProductList({...userRole, allProducts: true}));
            dispatch(fetchInternalBranchList(userRole));
        }
    }, [dispatch, params.interOrderId, userRole]);

    const {
        items,
        fetchByIdStatus,
        error
    } = useSelector(state => state.internalOrder);

    const item = items.find(item => item.id === params.interOrderId);

    const products = item?.products || [];

    useEffect(() => {
        if (item && item.internalBranchName) {
            dispatch(fetchInternalEmployeeList({
                ...userRole,
                branchId: item.internalBranchName
            }));
        }
    }, [dispatch, userRole, item]);

    const tableColumns = getOrderItemTableColumns();
    const tableData = getOrderItemTableData({products, productList});

    const detailData = getDetailData({item, internalBranch, employee});

    // Define fallback URL if no state is present
    const fallbackUrl = `../?page=${currentPage}&limit=${limit}`;
    const stateUrl = location.state?.from || fallbackUrl;

    return (
        <>
            <SubHeader title="Internal Order Details">
                <Button to={stateUrl}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" &&
                    <>
                        <Detail inline={true} columns={{lg: 9, xl: 7}} data={detailData}/>

                        <h6 className="mt-4">Order Items</h6>
                        <Table className="mobile-responsive" columns={tableColumns} data={tableData}/>
                        {Array.isArray(item?.log) &&
                            item.log.length > 0 &&
                            (userRole?.roleSign === RoleSign.Admin || userRole?.roleSign === RoleSign.Owner) && (
                                <>
                                    <h5>Order activity log</h5>
                                    <div className="overflow-auto" style={{height: 700}}>
                                        {item?.log
                                            ?.slice() // make a copy to avoid mutating original array
                                            .reverse() // latest logs first
                                            .map((log, idx) => (
                                                <OrderInternalLog key={idx} logDetail={log}/>
                                            ))}
                                    </div>
                                </>
                            )}
                    </>
                }
            </div>
        </>
    )
}

export default DetailInternalOrder;